import { isMobileOrTablet } from '../mobile-utils';

/** Function to add bottom margin to product pages */
export const handleProductPages = (pageName: string) => {
  const caStoredPlacement = localStorage.getItem('caBottomPlacement');
  const caButton = document.getElementById('caHelpButton');

  if (pageName && pageName?.toLowerCase().includes('product page') && isMobileOrTablet() && caStoredPlacement && caButton != null) {
    console.info('caStoredPlacement ---> ', caStoredPlacement);
    caButton.style.marginBottom = caStoredPlacement;
    localStorage.removeItem('caBottomPlacement');
  }
};
